import { useState, useRef, useCallback, useEffect } from 'react';

const getSelection = (id, rows, getId) => {
  const selected = rows.find(o => getId(o) === id);
  return selected ? [selected] : undefined;
};

function usePendingSelection(id, rows, getId = o => o.id) {
  const ref = useRef(id);
  const [selected, setSelected] = useState();
  const setPendingSelectionId = useCallback((i) => {
    ref.current = i;
  }, []);

  const clearSelection = useCallback(() => {
    setSelected(undefined);
  }, []);

  let rrows = rows;
  useEffect(() => {
    if (id) {
      ref.current = id;
      rrows = rows.slice(); // Enforce the following hook to be invoked
    }
  }, [id]);

  useEffect(() => {
    if (ref.current) {
      const newSelected = getSelection(ref.current, rrows, getId);
      if (newSelected) {
        ref.current = undefined;
        setSelected(newSelected);
      }
    }
  }, [rrows]);

  return { selected, onSelect: selected ? clearSelection : undefined, setPendingSelectionId };
}

export default usePendingSelection;
